import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Accordion, Heading, HeadingLevel, Button, Colors, Typography, } from '../../../index';
const Styles = labelStyles('FAQ', {
    root: css `
    padding: 30px 20px;

    @media screen and (min-width: 650px) {
      padding: 50px 30px;
    }
  `,
    faqContent: css `
    max-width: 1170px;
    margin: 0 auto;
  `,
    heading: css `
    text-align: center;
    margin-bottom: 30px;
    color: ${Colors.neutral800};
    ${Typography.pageHeader5}
  `,
    ctaContainer: css `
    text-align: center;
    margin-top: 30px;

    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 650px) {
      margin-top: 30px;
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
    grid: css `
    display: grid;
    gap: 20px;

    @media screen and (min-width: 650px) {
      gap: 15px;
    }
  `,
});
export const FAQ = ({ heading = 'Frequently Asked Questions', items, children, ctaText, ctaHref, onCtaClick, }) => {
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("div", { css: Styles.faqContent },
            isolateComponent(HeadingLevel, null,
                isolateComponent(Heading, { css: Styles.heading }, heading)),
            items && items.length > 0 ? (isolateComponent("div", { css: Styles.grid }, items.map((item) => (isolateComponent(Accordion, { key: item.title, title: item.title, href: item.href, isInitiallyOpen: item.isInitiallyOpen, isOpen: item.isOpen, onToggle: item.onToggle }, item.content))))) : (children),
            ctaText && (ctaHref || onCtaClick) && (isolateComponent("div", { css: Styles.ctaContainer },
                isolateComponent(Button, { href: ctaHref, size: "small", onClick: onCtaClick }, ctaText))))));
};
//# sourceMappingURL=FAQ.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
